import React from 'react'
import { connect } from 'react-redux'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
// import { Button } from 'antd'
import QRCodeManager from 'qrcode.react'
import WhiteSpace from 'components/WhiteSpace'
import { Button, Drawer, Icon, Spin } from 'antd'
import { intl, recordCountlyEvent } from 'utils'
import { BotimIcon, PaybyIcon } from './AppIcon'
import { Flex } from 'antd-mobile'

const IMAGES = {
  payby: require('./images/PayBy Pay.png'),
  'totok-pay': require('./images/ToTok Pay.png'),
  'botim-pay': require('./images/BOTIM Pay.png'),
}

const ICONS = {
  payby: <PaybyIcon />,
  'botim-pay': <BotimIcon />,
  'totok-pay': <span><img height={24} src={require('./images/ToTok Pay.png')} /></span>,
}

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCalledDeeplink: false,
    }
  }

  handleSubmit = () => {
    const { submit, pageName, siteConfig, ...data } = this.props
    pageName &&
      recordCountlyEvent({
        page_name: pageName,
        event_name: 'pull',
        element_name: 'pull_pay',
        biz_tags: {
          channel: data.tabName.toLowerCase().replace(' ', '_'),
          trade_voucher_no: sessionStorage.orderNo,
        },
      })
    setTimeout(() => {
      this.setState({ isCalledDeeplink: true })
    }, 1000)
    submit({
      ...data,
      method: 'PAY_WITH_DEEPLINK',
    })
  }

  render() {
    const {
      siteConfig,
      scanPayUrl,
      hostApp,
      tabName,
      introduceMediaUrl,
      iconUrl,
      optAppItems = [],
      pageName,
    } = this.props
    const { isCalledDeeplink } = this.state
    if (siteConfig.isMobile) {
      return (
        <div className={classes.componentsPaymentMethodsApp}>
          {!isCalledDeeplink && (
            <Button
              block
              loading={isCalledDeeplink}
              type='default'
              size='large'
              style={{ borderColor:'var(--gray-7)', backgroundColor:'var(--gray-1)' }}
              onClick={this.handleSubmit}
            >
              {ICONS[hostApp]}
            </Button>
          )}
          <Drawer
            visible={isCalledDeeplink}
            height='300px'
            className={classes.calledDeepLinkDrawer}
            closable={false}
            placement='bottom'
          >
            <Flex direction='column' className='h-full'>
              <Flex.Item>
                <div>
                  <Flex direction='column' justify='center' className='text-center'>
                    <div className={classes.circleShadow}>
                      <Spin
                        spinning={isCalledDeeplink}
                        className={classes.spin}
                        indicator={
                          <Icon type='loading' style={{ fontSize: 60 }} spin />
                        }
                      />
                    </div>
                    <WhiteSpace size='xl' />
                    {intl().formatMessage(messages.Processing)}
                    <WhiteSpace size='sm' />
                    <div className='paragraph_regular text_secondary'>
                      {`${intl().formatMessage(messages.ProcessingDescription)}`}&nbsp;*
                      <i className='text_main paragraph_regular'>
                        {intl().formatMessage(hostApp === 'botim-pay' ? messages.HighlightBotimName : messages.HighlightPayByName)}
                      </i>
                      *
                    </div>
                  </Flex>
                </div>
                <WhiteSpace size='xl' />
                <WhiteSpace size='sm' />
              </Flex.Item>
              <div className='w-full'>
                <Button
                  block
                  type='primary'
                  size='large'
                  onClick={() => {
                    pageName &&
                      recordCountlyEvent({
                        page_name: pageName,
                        event_name: 'click',
                        element_name: 'retry',
                        biz_tags: {
                          trade_voucher_no: sessionStorage.orderNo,
                        },
                      })
                    this.setState({ isCalledDeeplink: false })
                  }}
                >
                  <span>{intl().formatMessage(messages.BacktoRetry)}</span>
                </Button>
              </div>
            </Flex>
          </Drawer>
          {!siteConfig.isMobile && <WhiteSpace size='xl' />}
          {optAppItems.indexOf('introduceMedia') > -1 && introduceMediaUrl && (
            <video className={classes.vedio} autoPlay muted loop playsInline>
              <source src={introduceMediaUrl} type='video/mp4' />
            </video>
          )}
          {!siteConfig.isMobile && <WhiteSpace />}
        </div>
      )
    }
    return (
      <div className={classes.componentsPaymentMethodsApp}>
        {scanPayUrl && (
          <QRCodeManager
            size={232}
            value={scanPayUrl}
            bgColor='transparent'
            imageSettings={{ src: iconUrl || IMAGES[hostApp], width: 24, height: 24, excavate: true }}
          />
        )}
        <div style={{ lineHeight: '24px' }}>
          <span className='iconfont iconSCANPAY font-24' style={{ verticalAlign: 'bottom' }} />{' '}
          {intl().formatMessage(messages.ScanandPayWith)} {tabName && tabName.replace(/ Pay$/, '')}
        </div>
        <WhiteSpace size='xl' />
        {optAppItems.indexOf('introduceMedia') > -1 && introduceMediaUrl && (
          <video className={classes.vedio} autoPlay muted loop playsInline>
            <source src={introduceMediaUrl} type='video/mp4' />
          </video>
        )}
        <WhiteSpace />
      </div>
    )
  }
}

export default connect(
  (state) => ({
    siteConfig: state.siteConfig,
  }),
  {}
)(App)
